import { createContext } from 'react';

export type FilterType = {
  search: string;
  province: string;
  insurerId: string;
  page: number;
};

export type FilterContextType = {
  filters: FilterType;
  updateFilters: (options: Partial<FilterType>) => void;
};

export const FilterContext = createContext<FilterContextType | undefined>(undefined);
